<template>
    <v-container fluid>   
      <v-layout row wrap>        
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="documents"
            :items-per-page="50"
            item-key="validityFrom"
            sort-by="validityFrom"
            :sort-desc="true"
            class="elevation-1"
            hide-default-footer
            >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Documents</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="900px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" :disabled="readonly" dark class="mb-2" v-on="on">Upload File</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <v-file-input
                              show-size
                              label="Upload New File"
                              v-model="files"
                              v-on:change="fileSelected"
                            ></v-file-input>
                          </v-flex>   
                          <v-flex xs12 sm6 md6>
                            <v-text-field v-model="editedItem.fileName" label="File Name" ></v-text-field>
                          </v-flex> 
                            <v-flex xs12 sm6 m64>
                              <v-combobox
                                :items="categoryList"
                                label="Select Category"
                                v-model="editedItem.category"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>                                                                                                                                                                                                            
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                      <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template> 
            <template v-slot:body.append>                    
            </template>             
            <template v-slot:item.action="{ item }">       
               <v-icon                  
                @click="downloadItem(item)">
               mdi-download
              </v-icon>       
              <v-icon                  
                @click="viewItem(item)">
               mdi-arrow-expand
              </v-icon>  
              <v-icon    
                :disabled="readonly"     
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
import formatPrice from '../helpers/formatter';
import DatePicker from '../components/DatePicker';
const API_URL = 'documents/';
const CATEGORIES_API_URL = 'definitions/documentCategories/masterCategory';

export default {
    name : 'Documents',
    props: {
      documents : Array,
      parentRecord : Number,
      masterCategory : String,
      readonly: Boolean,
      folderId: String
    },
    components:{
      DatePicker
    },
    data () {
    return {
      dialog: false,
      search: '', 
      files: [],
      categoryList: [],
      editedIndex: -1,
      editedItem: {
        criteria : ''
      },
      defaultItem: {},
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Create Date', align: 'center', sortable: true, value: 'createDate' },
        { text: 'Category', value: 'category.text' },
        { text: 'File Name', value: 'fileName' },
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },         
    formTitle () {
      return this.editedIndex === -1 ? 'New Document' : 'Edit Document'
    },
  },
  created() {    
    this.getCategoriesByMaster();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.documents.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },      
    deleteItem(item) {
      const index = this.documents.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.documents.splice(index, 1);
        this.deleteDocument(item);
      } 
    },
    save () {
      if (this.editedIndex > -1) {        
        this.updateDocument(this.editedItem);
      } else {
        this.addDocument(this.editedItem);         
      }      
    },
    addDocument(item){
      let formData = new FormData();

      if(this.files){
        formData.append("file", this.files);
        formData.append("id", this.editedIndex);
        formData.append("categoryId", item.category ? item.category.id : 0);
        formData.append("parentId", this.$route.params.id);
        formData.append("parentRecord", this.parentRecord);
        formData.append("folderId", this.folderId ? this.folderId : '');
        formData.append("fileName", item.fileName);
      }
      const headers = {
            "Content-Type": "multipart/form-data",            
            "Cache-Control": "no-cache",
        }

      this.$axios.post(this.$apiurl + API_URL, formData, { headers:  headers })
      .then(response => {        
        if (response.status === 201) {
          this.$radio.$emit('success', {message:'Document Uploaded Successfully'});
          this.documents.push(this.editedItem);  
          this.$emit('documentsChanged');          
          this.close();         
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    downloadItem(item){
      window.open(item.contentLink); 
    },
    viewItem(item){
      window.open(item.viewLink); 
    },
    fileSelected(item){
      if(item){
        this.editedItem.fileName = item.name;
      }else{
        this.editedItem.fileName ='';
      }
    },
    updateDocument(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        personnelId : this.$route.params.id,
        validityFrom: item.validityFrom,
        validityUntil: item.validityUntil,
        criteriaId: item.criteria.id
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.documents[this.editedIndex], this.editedItem);            
          this.close();
          this.$emit('performanceCriteriaChanged');
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    deleteDocument(item){
      let formData = new FormData();
      formData.append("categoryId", item.category ? item.category.id : 0);
      formData.append("parentId", this.$route.params.id);
      formData.append("parentRecord", this.parentRecord);

      const headers = {          
            "Cache-Control": "no-cache",
        }
        
      this.$axios.delete(this.$apiurl + API_URL+item.id, { data : formData}, { headers:  headers } )
      .then(response => {
        if (response.status === 200) {
          this.$radio.$emit('success', {message:'Document Deleted Successfully'});
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },            
    getCategoriesByMaster(master){         
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL+'/'+ this.masterCategory)
            .then(response => {
                this.categoryList = response.data;
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },           
  },
}
</script>
